// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"590":"bd3bc026","639":"3b913f89","848":"46c81abd"}[chunkId] + ".chunk.css";
};